import React from 'react';

import {
  BranchLocation,
  LocationTreeWithRoot,
  NodeIndex,
} from 'components/LocationTree/types';
import useKeyboardNavigation from '../../hooks/useKeyboardNavigation/useKeyboardNavigation';
import { useLocationTreeContext } from '../../context/LocationTreeContext';
import styles from '../../LocationTree.module.css';

interface LocationTreeKeyboardControllerProps {
  tree: LocationTreeWithRoot;
  nodeIndex: NodeIndex;
  focusedNodeId: string | null;
  setFocusedNodeId: (id: string | null) => void;
  onToggleOpen: (branch: BranchLocation) => void;
  children: React.ReactNode;
}

const LocationTreeKeyboardController: React.FC<
  LocationTreeKeyboardControllerProps
> = ({
  tree,
  nodeIndex,
  focusedNodeId,
  setFocusedNodeId,
  onToggleOpen,
  children,
}) => {
  const { onSelectedChange } = useLocationTreeContext();

  const { handleKeyDown } = useKeyboardNavigation({
    tree,
    nodeIndex,
    focusedNodeId,
    setFocusedNodeId,
    onToggleOpen,
    onSelectNode: onSelectedChange,
  });

  return (
    <ul
      role="tree"
      aria-label="Root Location Selector"
      className={styles.locationTree}
      onKeyDown={handleKeyDown}
    >
      {children}
    </ul>
  );
};

export default LocationTreeKeyboardController;
